// @flow
import * as React from "react";

import { Link } from "react-router-dom";

import FETCH from "services/fetch";
import AuthService from "services/auth";
import withErrorHandler from "hoc/withErrorHandler";

import PageTitle from "views/components/PageTitle";

import LoginForm from "./LoginForm";

import type { ContextRouter } from "react-router-dom";

import "./Login.scss";

type OwnProps = {
  ...ContextRouter,
};

type Props = {
  ...OwnProps,
  onError: (error: Object) => void,
};

function LoginPage(props: Props): React.Node {
  const handleLogin = (email: string, password: string, callback: (string) => void) => {
    FETCH({
      method: "post",
      url: "login",
      auth: {
        username: email,
        password: password,
      },
    })
      .then((res) => {
        if (res.headers && res.headers["access-token"]) {
          // $FlowFixMe
          AuthService.setToken(res.headers["access-token"]);

          // $FlowFixMe
          const { from } = props.location.state || {
            from: { pathname: "/", search: "" },
          };

          window.location.href = from.pathname + from.search;
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 400) {
          return callback(err.response.data);
        }

        if (err.response && err.response.status === 401) {
          return callback("The email or password you entered is incorrect");
        }

        return props.onError(err);
      });
  };

  return (
    <React.Fragment>
      <PageTitle title="Log in" />

      <div className="Login">
        <div className="Login__container">
          <h2 className="Login__title">Welcome back!</h2>

          <LoginForm onLogin={handleLogin} />

          <div className="text-center mt-3">
            <div className="mb-2">
              Don't have an account? <Link to="/signup">Sign up</Link>
            </div>
            {/* <div>
            <Link to="/forgot-password">Forgot your password?</Link>
          </div> */}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default withErrorHandler<OwnProps>(LoginPage);
